<app-main-navbar></app-main-navbar>
<!-- Page Title -->
<div class="page-title-area" [ngStyle]="{ 'background-image': 'url(' + pPImage + ')' }">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <h1 class="text-start" i18n="@@privacyPolicyTitle">Privacy Policy</h1>
      </div>
    </div>
  </div>
</div>

<!-- Content -->
<div class="terms-and_conditions-area ptb-80">
  <div class="container">
    <div class="row">
      <span *ngIf="privacyData !== undefined && privacyData.length > 0" i18n="@@validFromTermsField"
        >Valid from: {{ privacyData[0].validFrom | date: 'dd MMM yyyy' }}</span
      >
      <div
        *ngIf="privacyData !== undefined && privacyData.length > 0"
        [innerHTML]="privacyData[0].privacy | safeHtml"
      ></div>
    </div>
  </div>
</div>
